import * as React from 'react';
import {View} from 'react-native';
import {noop} from 'lodash';

import Icon from '/component/base/Icon';
import Text from '/component/base/Text';
import TouchableOpacity from '/component/base/TouchableOpacity';
import {Reports} from '/constant/TestIDs';
import {withCompetency, withTheme} from '/provider/ThemeProvider';
import {useTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';
import testProperties from '/util/testing/testProperties';

import {styles} from './ReportIconButton.style';

interface ReportIconButtonProps {
  getTheme: (key: string) => object;
  sortLabel: string | (() => string);
  direction: string;
  onPress: () => void;
  style: object;
  iconName: 'filter' | 'sort' | '';
  badgeCount: number;
  disabled: boolean;
}

export const ReportIconButton: React.FC<ReportIconButtonProps> = ({
  getTheme = noop,
  sortLabel = '',
  direction = '',
  onPress = noop,
  style: styleProp = {},
  iconName = '',
  badgeCount = 0,
  disabled = false,
}: ReportIconButtonProps) => {
  const {ts} = useTranslation('report.reportIconButton');

  const style = [styles.base, disabled ? styles.disabledContainer : null];
  style.push(styleProp.base);

  const textStyle = {
    ...styles.text,
    ...(styleProp.text || {}),
    ...(disabled ? styles.disabledText : null),
  };

  const iconStyle = {
    ...styles.icon,
    ...(styleProp.icon || {}),
    ...(disabled ? styles.disabledIcon : null),
  };

  const badgeStyle = [styles.badge];
  badgeStyle.push(getTheme('competency.backgroundColor'));

  let badgeText = `${badgeCount}`;
  if (badgeCount > 99) {
    badgeText = '99';
  }

  return (
    <TouchableOpacity
      style={style}
      accessibilityLabel={ts(
        'filter.accessibilityLabel',
        `${sortLabel} ${direction}`,
      )}
      onPress={onPress}
      disabled={disabled}
      accessibilityState={{disabled: disabled}}
      {...testProperties(null, true)}>
      <Text
        testID={Reports.reportSortButton}
        variant="button"
        style={textStyle}
        truncate>
        {sortLabel} {direction}
      </Text>
      <Icon name={iconName} style={iconStyle} />
      {badgeCount > 0 && (
        <View style={badgeStyle}>
          <Text variant="label" style={styles.badgeText}>
            {badgeText}
          </Text>
        </View>
      )}
    </TouchableOpacity>
  );
};

export default withHOC(withTheme, withCompetency)(ReportIconButton);
